import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { InternalNotificationsService } from '../services/internal-notificacions.service';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { QueryParamsNotifications } from '../models/notifications.model';
import { AuthService } from '@app/common/auth.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-view-internal-notifications',
  templateUrl: './view-internal-notifications.component.html',
  styleUrls: ['../internal-notifications.css'],
})
export class ViewInternalNotificationsComponent
  extends BaseComponent
  implements OnInit
{
  isLoading: boolean = false;
  id: any;
  message!: string;
  title!: string;
  notifications: any[] = [];
  attachments: any[] = [];
  creationDate: string = '';
  currentIndex!: number;
  userId: number = 0;

  params: QueryParamsNotifications = {
    page: this.authService.getCurrentPaginators.page,
    pageSize: this.authService.getCurrentPaginators.pageSize,
    title: '',
    from: null,
    to: null,
    seen: null,
  };

  constructor(
    private location: Location,
    private router: Router,
    private notificationService: InternalNotificationsService,
    private routes: ActivatedRoute,
    route: ActivatedRoute,
    menuService: MenusServices,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
  ) {
    super(route, menuService);
    this.id = this.routes.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.sendDataToMenu();
    this.getNotificationById();
  }

  getNotificationById() {
    this.isLoading = true;
    this.notificationService.getNotificationById(this.id).subscribe({
      next: (response) => {
        this.message = response.data.message;
        this.title = response.data.title;
        this.creationDate = response.data.creationDate;
        this.attachments = response.data.attachments;
        this.userId = response.data.userId;
        this.isLoading = false;
        this.getNotifications();
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }

  getNotifications() {
    this.isLoading = true;
    this.notificationService
      .listNotificationsUser(this.params, this.userId)
      .subscribe({
        next: (response) => {
          this.notifications = response.data;
          this.currentIndex = this.notifications.findIndex(
            (notification) => notification.notificationId == this.id
          );
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
        },
      });
  }

  navigateToPrevious() {
    const model = {
      list: [
        {
          notificationId: this.id,
          seenByUser: true,
        },
      ],
    };
    this.notificationService.markAsSeen(model).subscribe({
      next: (response) => {},
      error: (error) => {},
    });
    if (this.currentIndex >= 1) {
      this.currentIndex--;
      const previousNotification =
        this.notifications[this.currentIndex].notificationId;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`notifications/details/${previousNotification}`]);
      });
    }
  }

  // Navegar a la notificación siguiente
  navigateToNext() {
    const model = {
      list: [
        {
          notificationId: this.id,
          seenByUser: true,
        },
      ],
    };
    this.notificationService.markAsSeen(model).subscribe({
      next: (response) => {},
      error: (error) => {},
    });
    if (this.currentIndex < this.notifications.length - 1) {
      this.currentIndex++;
      const nextNotification =
        this.notifications[this.currentIndex].notificationId;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`notifications/details/${nextNotification}`]);
      });
    }
  }

  goBack() {
    this.location.back();
  }

  onNotificationBodyClick(event: MouseEvent): void {
    const raw = event.target;
    if (!(raw instanceof Element) && !(raw instanceof Text)) {
      return;
    }
    const el = (raw instanceof Element ? raw : raw.parentElement)?.closest(
      'a[href]',
    );
    if (!el || !(el instanceof HTMLAnchorElement)) {
      return;
    }
    const hrefAttr = el.getAttribute('href');
    if (
      !hrefAttr ||
      hrefAttr.startsWith('mailto:') ||
      hrefAttr.startsWith('javascript:')
    ) {
      return;
    }
    let path: string;
    try {
      const resolved = new URL(hrefAttr, window.location.href);
      if (resolved.origin !== window.location.origin) {
        return;
      }
      path = `${resolved.pathname}${resolved.search}${resolved.hash}`;
    } catch {
      return;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    path = this.mapLoyaltyCertificatePathForDashboard(path);
    event.preventDefault();
    event.stopPropagation();
    void this.router.navigateByUrl(path);
  }

  /**
   * Las notificaciones pueden traer el enlace de distribuidores
   * (/loyalty/certificates/view/:id). En dashboard el módulo vive bajo
   * /marketing/loyalty/...
   */
  private mapLoyaltyCertificatePathForDashboard(path: string): string {
    const m = path.match(/^\/loyalty\/certificates\/view\/(\d+)(.*)$/);
    if (m) {
      return `/marketing/loyalty/certificates/view/${m[1]}${m[2] ?? ''}`;
    }
    return path;
  }

  transformMessageToLink(message: string): SafeHtml {
    if (message.includes('<a')) {
      return this.sanitizer.bypassSecurityTrustHtml(message);
    }
    const urlRegex = /https?:\/\/\S+/;
    const urlMatch = message.match(urlRegex);

    if (urlMatch) {
      const url = urlMatch[0];
      const messageWithLink = message.replace(
        urlRegex,
        `<a href="${url}">${url}</a>`,
      );
      return this.sanitizer.bypassSecurityTrustHtml(messageWithLink);
    }
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }
}
